var f = Object.defineProperty, i = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var s = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, R = Object.prototype.propertyIsEnumerable;
var t = (e, r, o) => r in e ? f(e, r, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[r] = o, m = (e, r) => {
  for (var o in r || (r = {}))
    c.call(r, o) && t(e, o, r[o]);
  if (s)
    for (var o of s(r))
      R.call(r, o) && t(e, o, r[o]);
  return e;
}, a = (e, r) => i(e, p(r));
import d, { forwardRef as l } from "react";
import n from "../lib/SSRBase.mjs";
import u from "../defs/UsersFour.mjs";
const w = l((e, r) => /* @__PURE__ */ d.createElement(n, a(m({ ref: r }, e), { weights: u })));
w.displayName = "UsersFour";
export {
  w as UsersFour
};
